<ui-button
  class="filter-toggle-btn"
  [type]="isFilterEmpty ? 'primary' : 'secondary'"
  size="small"
  (click)="onFilterCollapsed()"
>
  <ui-icon name="filter" size="18px"></ui-icon>
</ui-button>

<nz-drawer
  [nzClosable]="false"
  [nzVisible]="isFilterVisible"
  nzPlacement="right"
  (nzOnClose)="onFilterCollapsed()"
>
  <ng-container content *nzDrawerContent>
    <ui-filter
      collapsibleContent
      [form]="parkingMapFilterForm"
      [formConfig]="parkingMapFilterFormConfig"
      (filterClosed)="onFilterCollapsed()"
      (filterApplied)="applyFilter()"
    ></ui-filter>
  </ng-container>
</nz-drawer>

<div content class="map-container">
  <div class="map-type-controls">
    <button
      class="map-type-btn"
      [class.active]="selectedMapLayer === mapProviderTypeEnum.GIS2"
      (click)="changeMapLayer(mapProviderTypeEnum.GIS2)"
    >
      2GIS
    </button>
    <button
      class="map-type-btn"
      [class.active]="selectedMapLayer === mapProviderTypeEnum.Google"
      (click)="changeMapLayer(mapProviderTypeEnum.Google)"
    >
      Google
    </button>
    <button
      class="map-type-btn"
      [class.active]="selectedMapLayer === mapProviderTypeEnum.OSM"
      (click)="changeMapLayer(mapProviderTypeEnum.OSM)"
    >
      OSM
    </button>
  </div>

  <button class="heatmap-toggle" (click)="toggleHeatmap()">
    <ui-icon [name]="isHeatmapMode() ? 'group' : 'ungroup'"></ui-icon>
  </button>

  <button class="color-toggle" [class.active]="isGrayscale" (click)="toggleMapColor()">
    <svg width="24" height="24" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20V4Z"
      />
    </svg>
  </button>

  <div id="map"></div>
</div>
